<template>
    <div id="authTel" class="dialog-container">
        <div class="container">
            <div class="title">输入手机号，绑定课程~</div>
            <div class="tel-container">
                <input class="tel-model" v-model="tel" placeholder="请输入手机号" />
                <span class="tip" v-if="tel.length !== 0">{{tel.length}}/11</span>
            </div>
            <div @click="onSubmit" class="sub-btn">提交</div>
        </div>
    </div>
</template>
<script>
import { bindTel } from '@/utils/api'
import { setUserInfo, getUserInfo } from '@/utils/login.js'

export default {
    name: 'authTel',
    data() {
        return {
            tel: '',
        }
    },
    methods: {
        onSubmit() {
            if (!new RegExp(/^1[3-9]\d{9}$/).test(this.tel)) {
                return this.$toast('手机号格式错误')
            }

            this.$toast.loading({ message: '加载中...', forbidClick: true })
            const userInfo = getUserInfo()
            bindTel(this.tel).then(() => {
                userInfo.telNo = this.tel
                setUserInfo(userInfo)
                this.$toast({ className: 'success-toast', message: '绑定成功' })
                this.$emit('authSuccess', userInfo)
            })
        },
    },
}
</script>
<style lang="scss">
.dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
#authTel {
    .container {
        width: 280px;
        height: 200px;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
    }
    .tel-container {
        height: 42px;
        width: 180px;
        position: relative;
        .tip {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 10px;
            color: #999;
        }
    }
    .tel-model {
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        border: 1px solid #aaa;
        border-radius: 2px;
        font-size: 14px;
        padding: 0 12px;
    }
    .sub-btn {
        width: 180px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #44cd94;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
    }
}
</style>
